import APIService from '@/services/api-service'
const resource = '/job'
const subResource = 'letter'

class LetterService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getJobLetter (id: number) {
    return this.connector.get(`${resource}/${subResource}/${id}/body`)
  }

  public save (data: any) {
    return this.connector.post(`${resource}/${subResource}/save-body`, data)
  }
}

export default new LetterService()
